var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2456 8.00995H9C7.34315 8.00995 6 9.35309 6 11.0099V23.5013C6 25.1582 7.34315 26.5013 9 26.5013H21.4914C23.1483 26.5013 24.4914 25.1582 24.4914 23.5013V17.2556H21.9914V23.5013C21.9914 23.7775 21.7675 24.0013 21.4914 24.0013H9C8.72386 24.0013 8.5 23.7775 8.5 23.5013V11.0099C8.5 10.7338 8.72386 10.5099 9 10.5099H15.2456V8.00995Z",
    fill: "#00509D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 15.2457V8C26 6.89543 25.1046 6 24 6L17.1563 6L17.1563 8.5L22.1467 8.5L16.8445 13.8022L18.3546 15.3122L23.5 10.1668L23.5 15.2457L26 15.2457Z",
    fill: "#5C8FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoutIcon);
export default __webpack_public_path__ + "static/media/popout-icon.ed73df503660db7e989456b09053e38c.svg";
export { ForwardRef as ReactComponent };